
import { Vue, Component, Prop } from "vue-property-decorator";
import domtoimage from "dom-to-image";
import { Loading } from "element-ui";
import { formatUpyunUrl } from "@/utils";
import { dateToStr, numToStrM } from "@/utils/index";
@Component({
  components: {},
  filters: {
    getStatus(type: any): string {
      let txt = "";
      if (type == 0) {
        if (window.$getCookie("zh_choose") == "t") {
          txt = "學習中";
        } else {
          txt = "学习中";
        }
      } else if (type == 1) {
        if (window.$getCookie("zh_choose") == "t") {
          txt = "未完成學習";
        } else {
          txt = "未完成学习";
        }
      } else if (type == 2) {
        if (window.$getCookie("zh_choose") == "t") {
          txt = "結業";
        } else {
          txt = "结业";
        }
      } else if (type == 3) {
        if (window.$getCookie("zh_choose") == "t") {
          txt = "畢業";
        } else {
          txt = "毕业";
        }
      }
      return txt;
    }
  }
})
export default class MBA extends Vue {
  dUser = require("@/assets/images/user.png");
  @Prop({ default: {} }) info!: any;
  isDown = false;
  formatUpyunUrl = formatUpyunUrl;
  dateToStr = dateToStr;
  numToStrM = numToStrM;

  reduMonths(startMonth: any, endMonth: any) {
    let startY = startMonth.split("-")[0],
      startM = startMonth.split("-")[1],
      endY = endMonth.split("-")[0],
      endM = endMonth.split("-")[1];
    startMonth = startY + startM;
    endMonth = endY + endM;
    if (startMonth > endMonth) {
      let reduY = startY - endY,
        reduM = startM - endM;
      return reduY * 12 + reduM;
    } else if (startMonth < endMonth) {
      let reduY = endY - startY,
        reduM = endM - startM;

      return reduY * 12 + reduM;
    } else {
      return 0;
    }
  }

  save(index: number) {
    let load = Loading.service({
      lock: true,
      text: "生成图片中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.9)"
    });
    let node: any = null;
    let txt = "";
    if (index === 1) {
      node = document.getElementById("certificate");
      txt = "MBA学籍";
    } else {
      node = document.getElementById("certificate2");
      txt = "MBA毕业证书";
    }
    const scale = 2;
    const options = {
      width: node.clientWidth * scale,
      height: node.clientHeight * scale,
      style: {
        transform: "scale(" + scale + ")",
        transformOrigin: "top left"
      }
    };
    const that = this;

    this.isDown = true;
    domtoimage.toPng(node, options).then(function(dataUrl: any) {
      let eleLink = document.createElement("a");
      eleLink.href = dataUrl; // 转换后的图片地址
      eleLink.download = txt;
      document.body.appendChild(eleLink);
      eleLink.click();
      document.body.removeChild(eleLink);
      that.isDown = false;
      load.close();
    });
  }
}
